var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container not-found-page"},[_c('div',{staticClass:"not-found-page"},[_c('h1',[_vm._v("401")]),_c('img',{attrs:{"height":"300px","src":"https://offthecouch.io/img/pandas/angry.png"}}),_c('p',{staticClass:"mt-4"},[_vm._v("You are not authorized to view this page.")])])])
}]

export { render, staticRenderFns }